import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { volumeIncludes, volumes } from '../data/salesContent';
export function VolumesSection() {
  return <section className="w-full bg-ink-900 py-16 sm:py-24" aria-labelledby="volumes-title" data-id="element-178" data-mp="cp0zqecx549g">
      <div className="mx-auto max-w-6xl px-5" data-id="element-179" data-mp="7po3j305qku7">
        <div className="text-center" data-id="element-180" data-mp="7pxuotwxuy1h">
          <span className="inline-flex items-center rounded-full border border-lilac-500/40 bg-lilac-500/10 px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.18em] text-lilac-300" data-id="element-181" data-mp="3g57rpnlz1d2e">
            🏆 The Core-Floor Blueprint™ by Redondoland
          </span>
          <h2 id="volumes-title" className="mx-auto mt-6 max-w-3xl font-display text-3xl font-bold leading-tight text-white sm:text-[2.75rem]" data-id="element-182" data-mp="3pwlvw8ovb11v">
            The complete system. <span className="text-lilac-400" data-id="element-183" data-mp="2xd5jn0neb53r">Nothing missing.</span>
          </h2>
          <p className="mt-4 text-xs font-bold uppercase tracking-[0.22em] text-gold" data-id="element-184" data-mp="2selsmlty334j">
            💪 6 Complete Volumes
          </p>
        </div>

        <ol className="mt-12 grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-185" data-mp="29dnyxtwk3482">
          {volumes.map(v => <li key={v.number} className="flex flex-col rounded-2xl border border-white/10 bg-ink-700 p-7" data-id="element-186" data-mp="2j5blphi63x37">
              <span className="font-display text-4xl font-bold leading-none text-lilac-500/40" data-id="element-187" data-mp="2o33himlxo3co">
                {v.number}
              </span>
              <h3 className="mt-4 font-display text-xl font-bold text-white" data-id="element-188" data-mp="1vfpq14107zzy">{v.title}</h3>
              <p className="mt-3 text-[15px] leading-relaxed text-body" data-id="element-189" data-mp="1vhkayic9zs41">{v.description}</p>
            </li>)}
        </ol>

        <div className="mt-10 rounded-2xl border border-lilac-500/20 bg-ink-600 px-6 py-8 sm:px-10" data-id="element-190" data-mp="24gxe6t9t3kgb">
          <h3 className="font-display text-xl font-bold text-white" data-id="element-191" data-mp="3buqyabphdy18">
            Every volume includes:
          </h3>
          <ul className="mt-5 grid gap-3 sm:grid-cols-2" data-id="element-192" data-mp="3fu9jl8l7sb4l">
            {volumeIncludes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-193" data-mp="1gphsetfu4o6r">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-success" strokeWidth={3} aria-hidden="true" data-id="element-194" data-mp="1bs9bsxac4s7m" />
                <span className="text-[15px] leading-relaxed text-lilac-100" data-id="element-195" data-mp="1ksefawcer6gi">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="mt-10 flex justify-center" data-id="element-196" data-mp="x3mtqntbpmcp">
          <CtaButton data-id="element-197" data-mp="t1i4005zx9vc" />
        </div>
      </div>
    </section>;
}